const splitter = (figure) => {
    const parts = figure.split(',');
    if (parts[0] === '--') {
        return { wholeNumber: '--', decimal: '' };
    }
    if (parts.length === 1) {
        parts.push('00');
    }
    const wholeNumber = parts[0].toString().concat(',');
    const decimal = parts[1].toString();
    const figured = { wholeNumber, decimal };
    return figured;
};
export { splitter };
//# sourceMappingURL=splitter.js.map